/**
 * Suggestion pills rendered below assistant messages.
 * Shows LLM-generated, action-oriented labels as clickable pills.
 * Uses staggered spring entrance with hover/tap micro-interactions.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { chipContainerVariants, chipVariants } from './animations';

interface Props {
  labels: string[];
  onSelect: (label: string) => void;
  disabled?: boolean;
}

const InsightSuggestionPills: React.FC<Props> = ({ labels, onSelect, disabled }) => {
  if (labels.length === 0) return null;

  return (
    <motion.div
      variants={chipContainerVariants}
      initial="initial"
      animate="animate"
    >
      <div className="flex flex-wrap gap-2">
        {labels.map((label) => (
          <motion.button
            key={label}
            variants={chipVariants}
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={() => !disabled && onSelect(label)}
            disabled={disabled}
            className={`rounded-full border px-3.5 py-1.5 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
              disabled
                ? 'border-border/40 bg-muted/50 text-muted-foreground cursor-default'
                : 'border-border/60 bg-card text-heading hover:border-primary/40 hover:bg-primary/5'
            }`}
          >
            {label}
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
};

export default InsightSuggestionPills;
